import {Component, Input, OnInit} from '@angular/core';
import {IAbout} from 'projects//paid_ukr/src/app/components/about-us/about-us.service';

@Component({
  selector: 'app-about-us-b-item',
  templateUrl: './about-us-item.component.html',
  styleUrls: ['./about-us-item.component.scss']
})
export class AboutUsBItemComponent implements OnInit {

@Input()item: IAbout;
  constructor() { }

  ngOnInit(): void {
  }

}
